export const IconWallet = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.0013 8.20003H8.0013C5.05464 8.20003 2.66797 10.5867 2.66797 13.5334V8.71997C2.66797 5.99997 4.86797 3.79996 7.58797 3.79996H15.0813C17.8013 3.79996 20.0013 5.48003 20.0013 8.20003Z" />
      <path opacity="0.4" d="M23.3079 16.2667C22.6413 16.92 22.3213 17.9067 22.588 18.9067C22.9213 20.1467 24.148 20.9334 25.428 20.9334H26.668V22.8667C26.668 25.8134 24.2813 28.2 21.3346 28.2H8.0013C5.05464 28.2 2.66797 25.8134 2.66797 22.8667V13.5334C2.66797 10.5867 5.05464 8.20004 8.0013 8.20004H21.3346C24.268 8.20004 26.668 10.6 26.668 13.5334V15.4666H25.2279C24.4813 15.4666 23.8013 15.76 23.3079 16.2667Z" />
      <path d="M29.3349 16.8267V19.5733C29.3349 20.32 28.7215 20.9334 27.9615 20.9334H25.3882C23.9482 20.9334 22.6283 19.88 22.5083 18.44C22.4283 17.6 22.7482 16.8134 23.3082 16.2667C23.8016 15.76 24.4816 15.4666 25.2282 15.4666H27.9615C28.7215 15.4666 29.3349 16.08 29.3349 16.8267Z" />
      <path d="M17.332 15.8667H9.33203C8.78536 15.8667 8.33203 15.4134 8.33203 14.8667C8.33203 14.32 8.78536 13.8667 9.33203 13.8667H17.332C17.8787 13.8667 18.332 14.32 18.332 14.8667C18.332 15.4134 17.8787 15.8667 17.332 15.8667Z" />
    </svg>
  );
};
